import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useLocalizedState } from '@treams/treams-hooks';
import { AddIcon } from '@treams/treams-icons';
import * as graphql from '@treams/treams-network';
import { Button, Input, Label, Modal, Popover } from '@treams/treams-ui';

export default function CreateEngagementCategory(props: {
	onCreate: (category: graphql.EngagementCategory) => void;
}) {
	const { t } = useTranslation();

	const [visible, setVisible] = useState(false);
	const [title, setTitle] = useState<graphql.LocalizedString>([]);
	const [localizedTitle, setLocalizedTitle] = useLocalizedState(title, setTitle);

	const [create] = graphql.useCreateEngagementCategoryMutation();

	return (
		<Popover.Target
			backdrop
			contents={
				<Modal width={400} height="auto">
					<Modal.Header title={t('settings.engagementLibrary.createCategory.title')} />
					<Modal.Contents>
						<Label mb={2}>{t('settings.engagementLibrary.createCategory.name.label')}:</Label>
						<Input value={localizedTitle} onChange={setLocalizedTitle} autoFocus />
					</Modal.Contents>
					<Modal.FormFooter
						onCancel={() => setVisible(false)}
						onSave={async () => {
							const response = await create({
								variables: { input: { title } },
							});
							props.onCreate(
								response.data!.createEngagementCategory.category as graphql.EngagementCategory,
							);
							setTitle([]);
							setVisible(false);
						}}
					/>
				</Modal>
			}
			visible={visible}
		>
			<Button
				type="primary"
				title={t('settings.engagementLibrary.createCategory.button')}
				icon={<AddIcon />}
				onClick={() => setVisible(true)}
			/>
		</Popover.Target>
	);
}
